export default __webpack_public_path__ + "static/media/logo.82ba57ae.svg";